import React, { useEffect, useState } from "react";

import { BsFillCheckCircleFill } from "react-icons/bs";
import { useLocation, useNavigate } from "react-router-dom";
import CourseBanner from "../../Components/Cards/CourseBanner";
import {
  Button,
  Description,
  SubTitle,
} from "../../Components/CustomComponents";
import LocationModal from "../../Components/Modals/LocationModal";
import VideoLinkModal from "../../Components/Modals/VideoLinkModal";
import styles from "./styles/Classes.module.scss";
import { WEB_ROUTES } from "../../constants";
import { useAttendClassMutation, useGetClassesByBatchIdQuery } from "../../Data/services/classesApi";
import _ from "lodash";
import { useSelector } from "react-redux";
import EmptyContainer from "../../Components/Container/EmptyContainer";
import { Spinner } from "react-bootstrap";
import { ErrorToast, SuccessToast } from "../../Hooks/useToast";

export default function Classes({ setPage }) {
  const navigate = useNavigate();
  const location = useLocation();
  const { item } = location.state || {};

  const [attendClass] = useAttendClassMutation();

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [videoLinkModal, setVideoLinkModal] = useState(null);
  const [locationModal, setLocationModal] = useState(null);

  const { isLoading, error } = useGetClassesByBatchIdQuery(item?.id, {
    skip: false,
    refetchOnMountOrArgChange: true
  })
  const { data } = useSelector(state => state.classes);


  useEffect(() => {
    if (_.isEmpty(item)) {
      navigate(`/${WEB_ROUTES.DASHBOARD}`)
    }
  }, [])


  const handleBackButtonClck = () => {
    navigate(-1);
  };


  const handleVideoLinkModalOpen = (item) => {
    setVideoLinkModal(item);
  };

  const handleVideoLinkModalClose = () => {
    setVideoLinkModal(null);
  };

  const handleLocationModalOpen = (item) => {
    setLocationModal(item);
  };

  const handleLocationModalClose = () => {
    setLocationModal(null);
  };


  const handleAttendClass = async () => {
    if (isSubmitted) return;

    try {
      setIsSubmitted(true)
      const active_class = data?.find((item => item.is_enrolled && !item.is_completed));
      await attendClass(active_class?.id).unwrap()
      SuccessToast("Successfully attend the class")
      setVideoLinkModal(false)
      setLocationModal(false)
      setIsSubmitted(false)
    }
    catch (err) {
      ErrorToast(err.data?.message || "Something went wrong. Please try again later")
      setIsSubmitted(false)
    }
  }


  return (
    <div className={styles.Classes}>
      {!!videoLinkModal ? (
        <VideoLinkModal
          handleModalClose={handleVideoLinkModalClose}
          data={videoLinkModal}
          hasAccess={!data?.some(item => !item?.is_completed && !!item.is_enrolled)}
          isAttendSubmitted={isSubmitted}
          handleAttendClass={handleAttendClass}
        // onLogout={handleLogout}
        />
      ) : null}

      {!!locationModal ? (
        <LocationModal
          handleModalClose={handleLocationModalClose}
          data={locationModal}
          hasAccess={!data?.some(item => !item?.is_completed && !!item.is_enrolled)}
          isAttendSubmitted={isSubmitted}
          handleAttendClass={handleAttendClass}
        // onLogout={handleLogout}
        />
      ) : null}

      {
        <CourseBanner
          hasBackButton={true}
          handleBackButtonClck={handleBackButtonClck}
          title={""}
          image_url={item?.image_url}
        />
      }
      <div className={styles.headerContainer}>
        <SubTitle text={""} />
      </div>

      <div className="my-3">
        <SubTitle text={item?.name} />
        <Description
          classes="lc-3"
          text={item?.description}
        />
      </div>

      <SubTitle text="Class to attend" />

      {
        isLoading ?
          <EmptyContainer text={<Spinner size="lg" />} classes="my-2" /> :
          (_.isEmpty(data) || error) ? <EmptyContainer classes="my-2 fs-4" /> :
            (data || [])?.map((item, index) => {
              return (
                <div
                  className="d-flex flex-row justify-content-between my-3 gap-3"
                  onClick={
                    !!item?.meeting_link
                      ? () => handleVideoLinkModalOpen(item)
                      : () => handleLocationModalOpen(item)
                  }
                >
                  <div class={styles.gradientBox}>
                    <div className={item?.is_completed ? "" : styles.whiteBox}>
                      <span
                        class={
                          item?.is_completed
                            ? styles.whiteNumber
                            : styles.gradientNumber
                        }
                      >
                        {index + 1}
                      </span>
                    </div>
                  </div>
                  <div className="d-flex flex-column justify-content-center w-100  align-content-between">
                    <SubTitle text={item?.title} />
                    <Description classes="lc-1" text={item?.description} />
                  </div>
                  <div>
                    {item?.is_enrolled ? (
                      <Button
                        text={
                          item?.is_enrolled
                            ? item?.is_completed
                              ? "Completed"
                              : "Enrolled"
                            : ""
                        }
                        classes={`rounded-5 px-4 py-2 my-2 fw-bold gradientBg`}
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              );
            })}

      {data?.find((item => item.is_enrolled && !item.is_completed)) ?
        <div className="mt-5">
          <Button
            classes={`rounded-4 px-4 py-3 my-2 fw-bold gradientBg shadowBlur`}
            onClick={handleAttendClass}
            text={
              (isSubmitted && !locationModal && !videoLinkModal) ? <Spinner /> :
                <div>
                  <BsFillCheckCircleFill size={24} /> Attend
                </div>
            }
          />
        </div>
        : ""}

    </div>
  );
}
